const REBUY_RETRY_DELAYS_MS = [120, 320, 700, 1300, 2200, 3400, 4800];

function callIfFunction(candidate: unknown, context?: unknown): boolean {
  if (typeof candidate !== "function") {
    return false;
  }

  try {
    (candidate as () => void).call(context);
    return true;
  } catch {
    return false;
  }
}

function tryOpenRebuySmartCart(): boolean {
  const smartCart = window.Rebuy?.SmartCart;
  if (!smartCart) {
    return false;
  }

  return (
    callIfFunction(smartCart.show, smartCart) ||
    callIfFunction(smartCart.open, smartCart) ||
    callIfFunction(smartCart.expand, smartCart) ||
    callIfFunction(smartCart.launch, smartCart)
  );
}

function hasRebuySmartCartCandidate(): boolean {
  return Boolean(window.Rebuy?.SmartCart);
}

function bootstrapRebuyRuntime(): void {
  const rebuy = window.Rebuy;
  if (!rebuy) {
    return;
  }

  callIfFunction(rebuy.importSmartCartModule, rebuy);
  callIfFunction(rebuy.init, rebuy);
  callIfFunction(rebuy.widgets?.init, rebuy.widgets);
  callIfFunction(rebuy.Widgets?.init, rebuy.Widgets);
  callIfFunction(rebuy.Widget?.init, rebuy.Widget);
  callIfFunction(rebuy.SmartCart?.reloadCart, rebuy.SmartCart);
  callIfFunction(rebuy.SmartCart?.refresh, rebuy.SmartCart);
}

function openNativeCartDrawer(): boolean {
  const cartDrawerSection = document.querySelector<HTMLElement>("[data-section-type='cart-drawer']");
  if (!cartDrawerSection) {
    return false;
  }

  const drawerStore = window.Spruce?.store?.("drawer");
  if (!drawerStore) {
    return false;
  }

  drawerStore.cartDrawerOpen = true;
  return true;
}

export function openPreferredCartDrawer(): void {
  if (tryOpenRebuySmartCart()) {
    return;
  }

  const preferRebuy = window.__rebalanceRebuyEnabled === true;
  if (!preferRebuy) {
    openNativeCartDrawer();
    return;
  }

  document.dispatchEvent(new CustomEvent("rebalance:load-rebuy"));
  bootstrapRebuyRuntime();

  REBUY_RETRY_DELAYS_MS.forEach((delayMs, index) => {
    window.setTimeout(() => {
      bootstrapRebuyRuntime();

      if (tryOpenRebuySmartCart()) {
        return;
      }

      if (index === REBUY_RETRY_DELAYS_MS.length - 1 && !hasRebuySmartCartCandidate()) {
        openNativeCartDrawer();
      }
    }, delayMs);
  });
}
